import { render } from "./TestCase.vue?vue&type=template&id=66981288"
import script from "./TestCase.vue?vue&type=script&lang=js"
export * from "./TestCase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__